"use client";

import React, { useState } from "react";
import { motion } from "motion/react";
import { Send, Sparkles } from "lucide-react";
import { toast } from "sonner";

export function Newsletter() {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate API call
    setTimeout(() => {
      toast.success("Subscribed successfully!", {
        description: "You'll receive the latest tech insights soon.",
      });
      setEmail("");
      setIsSubmitting(false);
    }, 1500);
  };

  return (
    <div className="relative overflow-hidden rounded-[3rem] bg-gradient-to-br from-violet-950/40 via-fuchsia-950/40 to-cyan-950/40 border border-violet-500/20 p-12 md:p-20 text-center">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-brand-primary/5 blur-[120px] rounded-full pointer-events-none" />
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="relative z-10 max-w-2xl mx-auto"
      >
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-violet-500/10 rounded-full border border-violet-500/20 mb-8">
          <Sparkles size={14} className="text-violet-400" />
          <span className="text-[10px] font-black uppercase tracking-[0.3em] text-violet-400">Stay Updated</span>
        </div>
        
        <h2 className="text-4xl md:text-6xl font-black uppercase tracking-tighter italic text-white mb-6 leading-none">
          Tech <span className="text-transparent bg-clip-text bg-gradient-to-r from-violet-400 to-fuchsia-400">Insights</span>
        </h2>
        
        <p className="text-neutral-400 text-lg mb-12 font-medium">
          Get the latest updates on web development, business automation, and modern design directly in your inbox.
        </p>

        <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-4">
          <input
            required
            type="email"
            placeholder="Enter your email"
            className="flex-1 bg-black/50 border border-neutral-800 rounded-2xl px-6 py-5 focus:outline-none focus:border-violet-500/50 transition-all font-bold text-white placeholder:text-neutral-700"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button
            disabled={isSubmitting}
            type="submit"
            className="bg-white text-black px-10 py-5 rounded-2xl font-black uppercase tracking-widest text-xs flex items-center justify-center gap-3 hover:bg-violet-600 hover:text-white transition-all duration-500 active:scale-95 disabled:opacity-50"
          >
            {isSubmitting ? "Joining..." : "Subscribe"}
            <Send size={16} />
          </button>
        </form>
        
        <p className="mt-6 text-[10px] font-black uppercase tracking-widest text-neutral-600">
          No spam. Just pure value. Unsubscribe anytime.
        </p>
      </motion.div>
    </div>
  );
}